<script>
//import { columns } from "./columns";
export default {
    name: "Assets",

    data () {

        return {
         //   columns,
            assets: [],
            assetcategories: [],
            depreciationmethods: [],
            departments: [],
             Coas: [],
            employees: [],
            jobTitles: [],
            
            asset: {
                assetId: 0,
                uSERNAME: this.$root.username,
                active: true,
            },
            addAsset: false,
        };
    },

    components: {

        'asset-register': () => import('./modals/asset-register.vue'),
    //    'employee-edit-role-form': () => import('./modals/EditRole.vue'),
    },

    mounted() {

      this.$root.loading = true;
      Promise.allSettled([
         this.fetchAssets()
         ,  this.fetchassetcategories()
         ,  this.fetchDepreciationmethods()
         ,  this.fetchChartOfAccounts()
         // this.fetchGender(),
       //   this.fetchJobTitles(), this.fetchDepartments(),
       //    this.fetchEmployees()
           ]).then(() => {
        this.$root.loading = false;
      }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchAssets() {
  
            return this.$http.get(`Accounts/GetAssets`).then(response => {
                this.assets = response.data;
                }).catch(() => {});
           
        },

        fetchassetcategories() {

          return this.$http.get(`Accounts/GetAssetCategories`).then(response => {
              this.assetcategories = response.data;
              
            }).catch(() => {});
         
        },  fetchDepreciationmethods() {

          return this.$http.get(`Accounts/GetDepreciationMethods`).then(response => {
              this.depreciationmethods = response.data;
              
            }).catch(() => {});
         
        },

        fetchJobTitles() {

          return this.$http.get(`Shared/GetJobTitles`).then(response => {
              this.jobTitles = response.data;
            }).catch(() => {});
        },

        fetchChartOfAccounts() {

          return this.$http.get(`Accounting/GetCOA`).then(response => {
              this.Coas = response.data;
          }).catch(() => {});
        },

        
    },
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <h5 class="text-sm font-medium">Assets</h5>
              </template>
              <template v-slot:card-body>
                <div class="w-full text-right">
                  <button 
                    class="btn-sm btn-primary text-xs rounded" 
                    @click.prevent="addAsset=true">
                      <i class="fa fa-plus"></i> Asset
                  </button>
                </div>
                <asset-register
                 :assetcategories="assetcategories"
                 :showModal="addAsset"
                 :depreciationmethods="depreciationmethods" 
                 :controlaccounts="Coas"
                 :asset="asset"
                 @refresh="fetchAssets"
                 @closeModal="()=>{
                   asset = {
                      assetId: 0,
                uSERNAME: $root.username,
                active: true,
                   };
                   addAsset=false;
                 }">
                </asset-register>
                <div class="w-full overflow-auto">
                  <table class="table table-hover">
                    <thead class="flex flex-col text-xs overflow-auto bg-blue-500  text-white">
                      <tr class="w-full flex">
                        <th class="p-tiny w-1/6">Asset Id</th>
                         <th class="p-tiny w-1/6">Asset Name</th>
                        <th class="p-tiny w-1/6">Asset Code</th>
                        <th class="p-tiny w-1/6">Serial Number</th>
                        <th class="p-tiny w-1/6">Initial Cost</th>
                        <th class="p-tiny w-1/6">Depreciation Method</th>
                        <th class="p-tiny w-1/6">Depreciation %</th>
                        <th class="p-tiny w-1/6">Current Value</th>
                        <th class="p-tiny w-1/12">Location</th> 
                        <th class="p-tiny w-1/12">Action</th>
                      </tr>
                    </thead>
                    <tbody class="flex flex-col  text-xs overflow-auto bg-gray-100" style="height:70vh;">
                      <tr class="w-full flex" v-for="(ast, idx) in assets" :key="idx">
                        <td class="p-tiny w-1/6">{{ ast.assetID}}</td>
                        <td class="p-tiny w-1/6">{{ ast.assetName }}</td>
                        <td class="p-tiny w-1/6">{{ ast.code }}</td>
                        <td class="p-tiny w-1/6">{{ ast.serialNumber }}</td>
                       <!-- <td class="p-tiny w-1/6">{{ ast.dob | dateFormat }}</td> -->
                         <td class="p-tiny w-1/6">{{ ast.cost }}</td>
                        <td class="p-tiny w-1/6">{{ ast.depreciationMethod }}</td>
                        <td class="p-tiny w-1/6">{{ ast.depreciationPercentage }}</td>
                        <td class="p-tiny w-1/6">{{ ast.currentValue }}</td>
                        <td class="p-tiny w-1/12">{{ ast.location }}</td> 
                        <td class="p-tiny w-1/12">
                            <button title="Edit" 
                              @click.prevent="()=>{
                                asset=ast;
                                addAsset=true;
                              }"
                              class="btn-primary btn-sm text-xs rounded mr-1">
                                <i class="fa fa-edit"></i>
                            </button> 
                            
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>
              <template v-slot:card-footer>
                <div class="w-full text-right">
                  <router-link :to="{ name: `master-data.index` }" class="btn-sm btn-danger text-xs rounded"><i class="fa fa-caret-left"></i> Back</router-link>
                </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
